import I18n from 'i18n-js';
import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import ListingsCollection from '@reverbdotcom/commons/src/components/listings_collection';
import { Paths } from '../shared/url_helpers';
import { graphql, ChildProps } from 'react-apollo';

import {
  withUserContext,
  IUserContext,
} from '@reverbdotcom/commons/src/components/user_context_provider';

import {
  rowQuery,
  MeRecommendedListings,
  useRecommendedListingsTracking,
  COMPONENT_NAME,
  experimentEnabled,
} from './recommended_listings_common';
import { userContextIsTrackable } from '@reverbdotcom/commons/src/elog/mparticle';

interface ExternalProps {
  limit?: number;
  offset?: number;
  minCount?: number;
}

export type IProps = ExternalProps & IUserContext;

export function RecommendedListingsRow(props: ChildProps<IProps, MeRecommendedListings.Query>) {
  const minCount = props.minCount || 1;
  const listings = props.data?.me?.recommendedListings?.listings || [];

  useRecommendedListingsTracking(props);

  if (!experimentEnabled(props)) { return null; }

  if (
    !props.data?.loading &&
      listings.length < minCount
  ) {
    return null;
  }

  return (
    <ListingsCollection
      componentName={COMPONENT_NAME}
      listings={listings}
      loading={props.data?.loading}
      title={I18n.t('discovery.recommendedListings.title')}
      callToAction={
        <CoreLink to={Paths.myRecommendations.expand({})}>
          {I18n.t('discovery.recommendedListings.cta')}
        </CoreLink>
      }
      largeTiles
    />
  );
}

const connect = graphql<IProps>(
  rowQuery,
  {
    options: (ownProps) => {
      return {
        ssr: false,
        variables: {
          loggedOut: !!ownProps.user?.loggedOut,
          experimentDisabled: !experimentEnabled(ownProps),
          limit: ownProps.limit,
          offset: ownProps.offset,
          shouldSkipTracking: !userContextIsTrackable(ownProps.user),
        },
      };
    },
  },
);

export default withUserContext<IProps>(connect(RecommendedListingsRow));
